<label class="checkbox">
  <input
    type="checkbox"
    class="checkbox__control"
    [checked]="isChecked()"
    [disabled]="isDisabled()"
    (change)="onValueChange($event)"
    (blur)="onTouched()"
  />

  <span class="checkbox__name">{{ label() }}</span>
</label>
